/// <amd-module name="VSSUI/Components/Observer/SelectionObserver" />
import * as React from "react";
import { ISelectionRange } from "VSSUI/Utilities/Selection";
import { UncheckedObserver } from "./Observer";
import { IObservableExpression } from "./Observer.Props";
import { ISelectionObserverProps } from "./SelectionObserver.Props";

export class SelectionObserver extends React.Component<ISelectionObserverProps> {
    public render() {
        const selectionObservable: IObservableExpression = { observableValue: this.props.selection, filter: this.onSelectionChanged };
        return <UncheckedObserver selectionObservable={selectionObservable}>{this.props.children}</UncheckedObserver>;
    }

    private onSelectionChanged = (value: ISelectionRange[], action: string) => {
        let shouldUpdate = false;
        if (action === "select" && this.props.onSelect) {
            shouldUpdate = this.props.onSelect(value);
        }
        if ((action === "select" || action === "unselect" || action === "set") && this.props.onSelectionChanged) {
            shouldUpdate = this.props.onSelectionChanged(this.props.selection.value, action);
        }
        return shouldUpdate;
    };
}
